
      // This code is going to be bundled into the .js output by Vite,
      // but only in production.
      import init from '/src/main.ts'
      import { domReady } from '/src/lib/helpers.ts'

      domReady.then(() => {
        const elements = document.querySelectorAll('[data-plugin="person-filter"]')
        for (const element of elements) {
          const options = JSON.parse(element.dataset.options ?? '{}')
          init(element, options)
        }
      })
    